<template>
  <router-view @reload_active_tab="reload_active_tab"></router-view>
</template>
<script>

export default {
  name: 'MainLayout',
  data() {
    return {};
  },
  methods: {
    reload_active_tab() {
      this.$emit("reload_active_tab");
    }
  },
};
</script>
